import axios from "axios";
import { API_URL } from "../Config";
import authHeader from "./auth-header";

const list = (values) => {
  return axios.get(API_URL + "department-detail", {
    headers: authHeader(),
    params: values,
  });
};
const create = (values) => {
  return axios.post(API_URL + "department-detail/create", values, {
    headers: authHeader(),
  });
};
const update = (values) => {
  return axios.post(API_URL + "department-detail/update", values, {
    headers: authHeader(),
  });
};
const destroy = (values) => {
  return axios.post(API_URL + "department-detail/destroy", values, {
    headers: authHeader(),
  });
};

const departmentDetailService = { list, create, update, destroy };

export default departmentDetailService;
